import React from 'react'
import { FieldProps, YesOrNoOrNegotiableString } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'
import { useTranslation } from 'react-i18next'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../../objectDetails/fields/common/PopoverContent'

export interface PetsAllowedProps extends FieldProps<OtherFacilitiesScreenValidationResult> {
  showTooltip?: boolean
}

const PetsAllowed: React.FC<PetsAllowedProps> = ({
  insertionData,
  screenName,
  wrapperClassName = 'grid-item one-whole',
  onChange,
  showTooltip = true,
}) => {
  const { t } = useTranslation()

  const labelText = t('wizard.screen.otherFacilities.petsAllowed')
  const label = showTooltip ? (
    <LabelWithTooltip
      inputId='pets-allowed'
      labelText={labelText}
      tooltipContent={<PopoverContent translationKey='wizard.screen.otherFacilities.petsAllowedTooltipText' />}
      showMandatory={false}
      placement='top'
    />
  ) : (
    labelText
  )

  return (
    <div className={wrapperClassName}>
      <ChipOptionField
        id='pets-allowed'
        propertyName='petsAllowed'
        translation='wizard.screen.otherFacilities.'
        labelNode={label}
        option={insertionData.petsAllowed}
        options={YesOrNoOrNegotiableString}
        onChange={(value) => onChange({ screen: screenName, property: 'petsAllowed' }, value)}
      />
    </div>
  )
}

export default PetsAllowed
